import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.contactCompany

function* contactCompanySagaTask({ payload }) {
    const query: any = payload.query || undefined
    const params: any = payload.params || {
        query: `{"company":"${payload?.id}"}`,
        addPresignedURL: true,
        populates: ['batch']
    }

    if (query) Object.assign(params, { query })

    try {
        const response = yield axios.get(`/companies/contacts`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* contactCompanySaga(): any {
    yield takeLatest<TaskAction>(onRequest, contactCompanySagaTask)
}

export default contactCompanySaga
